import {
  DatePickerInput as MantineDatePickerInput,
  DatePickerInputProps as MantineDatePickerInputProps,
} from '@mantine/dates';

export type DatePickerInputProps = MantineDatePickerInputProps;

export const DatePickerInput = MantineDatePickerInput;

DatePickerInput.displayName = 'DatePickerInput';
